import script from "./FrmRepairPartsSign.vue?vue&type=script&setup=true&lang=js"
export * from "./FrmRepairPartsSign.vue?vue&type=script&setup=true&lang=js"

import "./FrmRepairPartsSign.vue?vue&type=style&index=0&id=3d7e38c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7e38c8"]])

export default __exports__